<template>
  <div>
    <div class="columns">
      <div class="column is-9">
        <div class="title is-3">Certificates</div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-9">
        <div class="secondary-border">
          <b-field label="ID">
            <b-input v-model="ID" icon="key"></b-input>
          </b-field>
          <b-field label="Title">
            <b-input v-model="certificate.Title" icon="label"></b-input>
          </b-field>
          <div class="label">Certificates</div>
          <div
            class="columns"
            v-for="(key, i) in certificate.Certificates"
            :key="i"
          >
            <div class="column is-11">
              <b-input
                v-model="certificate.Certificates[i]"
                icon="label"
              ></b-input>
            </div>
            <div class="column">
              <b-button
                icon-left="delete-variant"
                type="is-warning"
                @click="remove(i)"
              ></b-button>
            </div>
          </div>
          <div class="buttons">
            <b-button
              icon-left="plus"
              @click="certificate.Certificates.push('')"
              expanded
              >Add Certificate ID</b-button
            >
          </div>
          <b-field label="Issued">
            <b-input v-model="certificate.Issued" icon="calendar"></b-input>
          </b-field>
          <div class="buttons">
            <b-button type="is-primary" @click="submit" expanded
              >Submit</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const moment = require("moment");
export default {
  data() {
    return {
      ID: "",
      certificate: {
        Title: "",
        Issued: "",
        Certificates: []
      },
      loader: null
    };
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.loader = this.$buefy.loading.open();
      this.$api.certificates
        .get()
        .then(certificates => {
          this.ID = this.$route.params.id;
          this.certificate = certificates[this.ID];
        })
        .catch(() => {
          this.$buefy.toast.open("Unable to perform request");
        })
        .finally(() => {
          this.loader.close();
          this.loader = null;
        });
    } else {
      this.certificate.Issued = moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    remove(pos) {
      const certificates = [];
      for (let i = 0; i < this.certificate.Certificates.length; i++) {
        if (i === pos) {
          continue;
        }
        certificates.push(this.certificate.Certificates[i]);
      }
      this.certificate.Certificates = certificates;
    },
    submit() {
      this.loader = this.$buefy.loading.open();
      this.$api.certificates
        .saveOrUpdate(
          this.ID,
          this.certificate,
          this.$route.params.id !== undefined
        )
        .then(() => {
          this.$buefy.toast.open("Action completed successfully");
          this.$router.push({ name: "home" });
        })
        .catch(() => {
          this.$buefy.toast.open("Unable to perform request");
        })
        .finally(() => {
          this.loader.close();
          this.loader = null;
        });
    }
  }
};
</script>
